import React from 'react'
import ContactUs from '../../components/Doctors/ContactUs'
const ContactPage = () => {
  return (
    <div>
      <ContactUs/>
    </div>
  )
}

export default ContactPage
